import React from 'react';
import TargetRelatedConfirmModal from './TargetRelatedConfirmModal';
import { TargetGoal } from 'hooks/useGrouping';

type AccountDeleteConfirmModalProps = {
  delete: () => void;
  close: () => void;
  targetGoal: TargetGoal | null;
  groupName: string;
  isShow: boolean;
};

const AccountDeleteConfirmModal: React.FC<AccountDeleteConfirmModalProps> = props => {
  const title = 'この口座を削除しますか？';

  const content = ((
    targetGoal: TargetGoal | null,
    groupName: string
  ): JSX.Element => {
    if (targetGoal) {
      return (
        <>
          この口座は現在「{targetGoal.title}」の目標設定のための資産「
          {groupName}」に登録されています。
          <br />
          削除後は目標の達成状況が変動する可能性があります。
          <br />
          この口座を削除してよろしいですか？
        </>
      );
    } else {
      return (
        <>
          削除するとアセットプランナー上のデータは削除され復元できなくなります。
          <br />
          この口座を削除してよろしいですか？
        </>
      );
    }
  })(props.targetGoal, props.groupName);

  const deleteButtonMessage = '削除する';

  return (
    <TargetRelatedConfirmModal
      targetGoalId={props.targetGoal ? props.targetGoal.id : undefined}
      execute={{
        execute: props.delete,
        executeButtonMessage: deleteButtonMessage,
      }}
      cancel={props.close}
      title={title}
      content={content}
      isShow={props.isShow}
      close={props.close}
    />
  );
};

export default AccountDeleteConfirmModal;
